import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

export default function CreditsDialog({ visible, onHide, currentCredits }) {
  const navigate = useNavigate();

  return (
    <Dialog
      header={
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#ff9800',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '14px',
            fontWeight: 'bold'
          }}>
            !
          </div>
          <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>No Credits Available</span>
        </div>
      }
      visible={visible}
      style={{ width: '450px' }}
      onHide={onHide}
      footer={
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-outlined"
            onClick={onHide}
          />
          <Button
            label="Buy More Credits"
            icon="pi pi-credit-card"
            className="p-button-primary"
            onClick={() => {
              onHide();
              navigate('/purchase');
            }}
          />
        </div>
      }
    >
      <div style={{ padding: '1rem 0' }}>
        <p style={{ 
          marginBottom: '1rem', 
          color: 'var(--text-secondary)',
          fontSize: '1.1rem',
          lineHeight: '1.5'
        }}>
          You don't have enough credits to unlock this profile. Purchase more credits to continue exploring candidate profiles.
        </p>
        <div style={{ 
          background: 'var(--surface-100)', 
          padding: '1rem', 
          borderRadius: '8px',
          border: '1px solid var(--surface-200)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <i className="pi pi-info-circle" style={{ color: 'var(--primary-color)' }}></i>
            <strong style={{ fontSize: '1.1rem' }}>Current Credits: {currentCredits || 0}</strong>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <i className="pi pi-lock" style={{ color: 'var(--red-500)' }}></i>
            <span style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>Credits needed: 1</span>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
